module.exports = __webpack_public_path__ + "img/icon_h-hotel.08f81bc0.png";